import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';
import { Select } from 'components/DesignSystem/Select';

export const ResourceType = ({ isSelected, options, onFiltersChanged, isLoading }) => {
    const { control } = useFormContext<IFields>();
    return isSelected ? (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Resource Type</span>
            <Controller
                render={({ field }) => (
                    <Select<ISelectOption<string>, true>
                        id={'battlecards-resource-type'}
                        {...field}
                        onChange={(newValue) => {
                            field.onChange(newValue);
                            onFiltersChanged({ [field.name]: newValue });
                        }}
                        isMulti
                        options={options}
                        isLoading={isLoading}
                    />
                )}
                name={'resourceType'}
                control={control}
            />
        </div>
    ) : null;
};
